<template lang="pug">
  Aside
    b-tabs
      b-tab
        template(slot="title")
          i.fa.fa-cog
        AsidebarLanguage
</template>

<script>
import config from "@/config";
import { Aside, Switch as cSwitch } from "@/library/coreui";
import AsidebarLanguage from "@/components/asidebarLanguage";

export default {
  components: {
    Aside,
    cSwitch,
    AsidebarLanguage
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>


